export default __webpack_public_path__ + "static/media/121-restaurant-crowd.3029935f.jpeg";